// ── PWA install capture ──────────────────────────────────────────────────────
// The browser fires `beforeinstallprompt` once on load for an installable,
// not-yet-installed PWA. If we don't grab it here (imported early in index.js),
// it's gone by the time React renders the InstallPrompt UI. We stash the event
// and let the component drive its own "Install EduMIS" popup.
let deferredPrompt = null;
const listeners = new Set();
const notify = () => listeners.forEach(fn => { try { fn(); } catch (_) { /* ignore */ } });

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();          // suppress the mini-infobar; we show our own UI
    deferredPrompt = e;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
  });
}

// True when EduMIS is already running as an installed app — PWA standalone,
// iOS "Add to Home Screen", or an Android TWA. The prompt must never show here.
export const isStandalone = () => {
  if (typeof window === 'undefined') return false;
  const mm = (q) => window.matchMedia && window.matchMedia(q).matches;
  return (
    mm('(display-mode: standalone)') ||
    mm('(display-mode: fullscreen)') ||
    mm('(display-mode: minimal-ui)') ||
    window.navigator.standalone === true ||           // iOS Safari
    document.referrer.startsWith('android-app://')     // Android TWA
  );
};

// iOS Safari never fires beforeinstallprompt — install there is manual (Share ▸
// Add to Home Screen), so we show instructions instead of an Install button.
export const isIOS = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /iphone|ipad|ipod/i.test(ua) ||
    // iPadOS 13+ masquerades as a Mac; a touch-capable "Mac" is really an iPad.
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const getDeferredPrompt   = () => deferredPrompt;
export const clearDeferredPrompt = () => { deferredPrompt = null; };
// Subscribe to availability changes (prompt captured / app installed). Returns
// an unsubscribe function.
export const onInstallChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
